import * as go from 'gojs';

export default ({ app }, inject) => {
  inject('go', go);
  inject('make', go.GraphObject.make);
}

